import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container">
        <p>&copy; {currentYear} SaveMove Umzüge. Alle Rechte vorbehalten.</p>
        <div className="footer-legal">
          <Link to="/impressum" className="footer-link">Impressum</Link>
          <span className="divider"> | </span>
          <Link to="/datenschutz" className="footer-link">Datenschutz</Link>
          <Link to="/agb" className="footer-link">AGB</Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;